module.exports = __webpack_public_path__ + "img/button_press down_04.bf9fd0a7.png";